import {
  PROPERTY_TYPE,
  PROPERTY,
} from "@pages/Dashboard/HomeDashboard/TotalSales/helper";

export const accessMappingData = {
  propertyRestaurantCateringRevenueCenters: [
    PROPERTY_TYPE.RESTAURANTS_CATERING_REVENUE_CENTERS,
  ],
  propertyPinnacle: [PROPERTY_TYPE.PINNACLE],
  hideStilePerCap: [
    PROPERTY_TYPE.RESTAURANTS_CATERING,
    PROPERTY_TYPE.QUICK_SERVICE_REVENUE_CENTERS,
    PROPERTY_TYPE.RESTAURANTS_CATERING_REVENUE_CENTERS,
    PROPERTY_TYPE.PINNACLE,
  ],
  hideGuestData: [
    PROPERTY_TYPE.QUICK_SERVICE_STORE,
    PROPERTY_TYPE.ALL,
    PROPERTY_TYPE.QUICK_SERVICE,
    PROPERTY_TYPE.QUICK_SERVICE_REVENUE_CENTERS,
    PROPERTY_TYPE.PINNACLE,
  ],
  hideGrossMargin: [
    PROPERTY_TYPE.QUICK_SERVICE_REVENUE_CENTERS,
    PROPERTY_TYPE.RESTAURANTS_CATERING_REVENUE_CENTERS,
    PROPERTY_TYPE.PINNACLE,
  ],
  quickServiceRevenueCenters: [PROPERTY_TYPE.QUICK_SERVICE_REVENUE_CENTERS],
  isQsPropertyStore: [PROPERTY_TYPE.QUICK_SERVICE_STORE],
  hideEventName: [PROPERTY_TYPE.ALL],
};
export type AccessMappingDataType = keyof typeof accessMappingData;

export const displayNotesProperties = [
  PROPERTY.BMO,
  PROPERTY.COCA_COLA_COLISEUM,
  PROPERTY.SCOTIABANK_ARENA,
];

export const accessMappingPropertyData = {
  hideDaypart: [
    PROPERTY.RESTAURANTS_CATERING,
    PROPERTY.PINNACLE,
    PROPERTY.MLSE,
  ],
  isQsProperty: [
    PROPERTY.BMO,
    PROPERTY.COCA_COLA_COLISEUM,
    PROPERTY.SCOTIABANK_ARENA,
  ],
};
export type AccessMappingPropertyDataType =
  keyof typeof accessMappingPropertyData;
